// service/otherChargeService.js
import { postAction, safeParseJson } from "./apiHelpers";

const URL = "https://pro.mokshiq.in/website_other_charge_manager";

// These fields are sent as JSON strings (see curl: quantity, unit, amount, created_by)
const JSON_FIELDS = ["quantity", "unit", "amount", "created_by"];

/**
 * Matches these curl actions:
 *   action=GET
 *   action=GETBYID&id=...
 *   action=ADDUPDATE&id=...(optional)&website_plan=...&service_name=...
 *            &domain_renewal=...&ssl=...&quantity={...json...}&unit={...json...}
 *            &amount={...json...}&day_applicable=...&quantity_applicable=...
 *            &status=...&created_by={...json...}
 *   action=DELETE&id=...
 *
 * quantity shape: { "default": 1, "min": 1, "max": 10 }
 * unit shape:     { "type": "Year" }
 * amount shape:   { "price": 999, "gst": 18 }
 */
export const otherChargeService = {
  getAll: () => postAction(URL, { action: "GET" }),

  getById: (id) => postAction(URL, { action: "GETBYID", id }),

  addOrUpdate: ({
    id,
    website_plan,
    service_name,
    domain_renewal = "false",
    ssl = "false",
    quantity,
    unit,
    amount,
    day_applicable = "false",
    quantity_applicable = "true",
    status = "true",
    created_by,
  }) =>
    postAction(
      URL,
      {
        action: "ADDUPDATE",
        ...(id ? { id } : {}),
        website_plan,
        service_name,
        domain_renewal,
        ssl,
        quantity,
        unit,
        amount,
        day_applicable,
        quantity_applicable,
        status,
        created_by,
      },
      JSON_FIELDS
    ),

  remove: (id) => postAction(URL, { action: "DELETE", id }),

  // Helper for consumers reading GET/GETBYID results — normalizes JSON columns
  // that may come back as strings from the backend.
  normalize: (record) => ({
    ...record,
    quantity: safeParseJson(record.quantity, { default: 1, min: 1, max: 1 }),
    unit: safeParseJson(record.unit, { type: "" }),
    amount: safeParseJson(record.amount, { price: 0, gst: 0 }),
    created_by: safeParseJson(record.created_by, {}),
  }),
};

export default otherChargeService;